import axiosInstance from '../axiosInstance';

export const logViewerApi = {
    post: (path, params, options, cancelToken) =>
        axiosInstance
            .post(`/LogViewer${path}`, params, {
                ...options,
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, options, cancelToken) =>
        axiosInstance
            .get(
                `/LogViewer${path}`,
                { ...params, ...options },
                {
                    cancelToken: cancelToken?.token
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const getLogFiles = async () => logViewerApi.get('/GetLogFiles');
export const getLogFileContent = async (fileName) => logViewerApi.get(`/GetLogFileContent/${fileName}`);
